import type { GrpcWebFetchTransport } from '@protobuf-ts/grpcweb-transport'; // импорт типа транспорта
import { AuthEndpointClient } from '@vpn-tg/vue-client-grpc/proto/auth/auth-endpoint.client'; // импорт клиента auth
import { UserEndpointClient } from '@vpn-tg/vue-client-grpc/proto/user/user-endpoint.client' // импорт клиента user
import { SettingsEndpointClient } from '@vpn-tg/vue-client-grpc/proto/settings/settings-endpoint.client' // импорт клиента settings
import { TariffEndpointClient } from '@vpn-tg/vue-client-grpc/proto/tariff/tariff-endpoint.client'
import { ServerEndpointClient } from '@vpn-tg/vue-client-grpc/proto/server/server-endpoint.client'
import { TransactionEndpointClient } from '@vpn-tg/vue-client-grpc/proto/transaction/transaction-endpoint.client'
import { UserToServerEndpointClient } from '@vpn-tg/vue-client-grpc/proto/userToServer/user-to-server-endpoint.client'
import { MailingEndpointClient } from '@vpn-tg/vue-client-grpc/proto/mailing/mailing-endpoint.client'
import { GuideEndpointClient } from '@vpn-tg/vue-client-grpc/proto/guide/guide-endpoint.client'
import { SubscriptionEndpointClient } from '@vpn-tg/vue-client-grpc/proto/subscription/subscription-endpoint.client'
import { SavedPaymentMethodEndpointClient } from '@vpn-tg/vue-client-grpc/proto/savedPaymentMethod/savedPaymentMethod-endpoint.client'
import { grpcTransport } from '@/grpc-client/grpc/grpc-transport'; // импорт настроенного транспорта

/**
 * Фабрика для создания gRPC-клиентов
 * @param transport - экземпляр GrpcWebFetchTransport
 * @returns объект с клиентами gRPC
 */
export const clientBuilder = (transport: GrpcWebFetchTransport) => ({
  authEndpoint: new AuthEndpointClient(transport), // клиент для authEndpoint
  SettingsEndpoint: new SettingsEndpointClient(transport),
  UserEndpoint: new UserEndpointClient(transport),
  TariffEndpoint: new TariffEndpointClient(transport),
  TransactionEndpoint: new TransactionEndpointClient(transport),
  ServerEndpoint: new ServerEndpointClient(transport),
  UserToServerEndpoint: new UserToServerEndpointClient(transport),
  MailingEndpoint: new MailingEndpointClient(transport),
  GuideEndpoint: new GuideEndpointClient(transport),
  SavedPaymentMethodEndpoint: new SavedPaymentMethodEndpointClient(transport),
  SubscriptionEndpoint: new SubscriptionEndpointClient(transport),
});

/**
 * Глобальный объект с gRPC-клиентами, готовый к использованию
 */
export const $grpcClient = clientBuilder(grpcTransport);
